import React, { FC, useCallback, useEffect, useState } from "react";
import { AdUploadFiles } from "../AdUploadFiles";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAgencyQuotesFormDataAction,
  getFilesByStageAction,
} from "../../../../store/actions/raiseAdRequest";
import { openToast } from "../../../../Toasts";
import {
  canPerformAction,
  handleUploadNoticeFiles,
  StepKeysName,
  StepNames,
} from "../../../RaiseNoticeAdRequest/utils";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";
import { Form } from "antd";
import { DatePicker } from "pyxis-ui-kit";
import moment from "moment";
// import { AdUploadFiles } from "../AdUploadFiles";

const permittedRoles = ["admin", "designer-own-access", "product-admin"];
export const UploadProofForm: FC = () => {
  const dispatch = useDispatch();
  const { selectedProductId, requestId } = useParams<{
    selectedProductId: string;
    requestId: string;
  }>();
  const {
    estimatesProof,
    softCopyProof,
    userRole,
    lastStepName,
    isFileUploading,
    quoationApprovalFormData,
    quoteDetailsFormData,
  } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );

  const [form] = Form.useForm();

  const isStepAccessible = canPerformAction(
    userRole,
    permittedRoles,
    StepNames[5],
    lastStepName,
    quoationApprovalFormData.trashed_at
  );

  const [estimatesFile, setEstimatesFile] = useState<any[]>(estimatesProof);
  const [softCopyFile, setSoftCopyFileFile] = useState<any[]>(softCopyProof);
  useEffect(() => {
    setEstimatesFile(estimatesProof);
    setSoftCopyFileFile(softCopyProof);
  }, [estimatesProof, softCopyProof]);

  useEffect(() => {
    if (quoteDetailsFormData?.data?.[0]?.release_date) {
      form.setFieldsValue({
        release_date: !!quoteDetailsFormData?.data?.[0]?.release_date
          ? moment(quoteDetailsFormData?.data?.[0]?.release_date)
          : null,
      });
    }
  }, [form, quoteDetailsFormData]);
  useEffect(() => {
    dispatch(getAgencyQuotesFormDataAction(requestId));

    dispatch(
      getFilesByStageAction({
        stage: "Upload Proof",
        request_id: requestId,
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isStepAccessible && !!userRole) {
      openToast("info", "You only have view access to this information.");
    }
  }, [isStepAccessible, userRole]);

  const handleSubmitUploadFile = useCallback(() => {
    const release_date = form.getFieldValue("release_date");
    if (!release_date) return;
    const allFiles = [
      ...(!!estimatesProof.length ? [] : estimatesFile),
      ...(!!softCopyProof.length ? [] : softCopyFile),
    ];
    if (!estimatesFile.length || !softCopyFile.length) {
      openToast("error", "Please upload pdf file");
      return;
    }
    handleUploadNoticeFiles(
      allFiles,
      dispatch,
      requestId,
      "Review and Close",
      "Upload Proof",
      StepKeysName.ReviewAndClose,
      selectedProductId,
      false,
      {},
      "",
      "",
      release_date?.format?.("YYYY-MM-DD")
    );
  }, [
    dispatch,
    estimatesFile,
    estimatesProof.length,
    form,
    requestId,
    selectedProductId,
    softCopyFile,
    softCopyProof.length,
  ]);

  return (
    <>
      <Form form={form} className="custom-form">
        <div className="layout-wrapper">
          {/* Scrollable Form */}
          <div className="layout-wrapper__body">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                marginTop: "2rem",
              }}
            >
              <div
                style={{
                  color: "#000",
                  fontSize: "1.8rem",
                  fontWeight: 500,
                }}
              >
                Review Date
              </div>
              <Form.Item
                label="Add Review Date"
                name="release_date"
                rules={[
                  {
                    required: true,
                    message: "Please select the final release date",
                  },
                ]}
                valuePropName="value"
                getValueFromEvent={(value) => value}
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  placeholder="Select date"
                  style={{
                    padding: "0.6rem 1rem",
                    width: "26rem",
                    borderRadius: "6px",
                  }}
                  disabled={!isStepAccessible}
                />
              </Form.Item>
              {/* </Form> */}
              <div
                style={{
                  color: "#000",
                  fontSize: "1.8rem",
                  fontWeight: 500,
                }}
              >
                Upload Proof of Publishing from agency end
                <span style={{ color: "red" }}>*</span>
              </div>

              <div
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 500,
                  color: "#556179",
                }}
              >
                Upload the necessary files for processing:{" "}
                <span style={{ color: "#6B38C4" }}>
                  Estimates* and Soft Copies*
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  gap: "1.5rem",
                }}
              >
                <AdUploadFiles
                  accept=".pdf"
                  isHalfWidthReq={true}
                  uploadTitle="Upload Estimates from computer"
                  fileList={estimatesFile}
                  setFileList={setEstimatesFile}
                  currentStage={"Upload Proof"}
                  prefix="Estimates_Proof"
                  isUesrPermitted={isStepAccessible}
                />
                <AdUploadFiles
                  accept=".pdf"
                  isHalfWidthReq={true}
                  uploadTitle="Upload Soft Copies from computer"
                  fileList={softCopyFile}
                  setFileList={setSoftCopyFileFile}
                  currentStage={"Upload Proof"}
                  prefix="Soft_Copy_Proof"
                  isUesrPermitted={isStepAccessible}
                />
              </div>
            </div>
          </div>
          {!!isStepAccessible ? (
            <div className="layout-wrapper__footer">
              <button
                className="btn btn--purple"
                onClick={handleSubmitUploadFile}
                disabled={!estimatesFile.length || !softCopyFile.length}
                type="submit"
              >
                Next
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Form>
    </>
  );
};
